'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');
var _UserAuthenticationBody = require('../../components/UserAuthentication/UserAuthenticationBody/UserAuthenticationBody');var _UserAuthenticationBody2 = _interopRequireDefault(_UserAuthenticationBody);
var _SocialNetworkAuthentication = require('../../components/UserAuthentication/SocialNetworkAuthentication/SocialNetworkAuthentication');var _SocialNetworkAuthentication2 = _interopRequireDefault(_SocialNetworkAuthentication);
var _ForgotPasswordBody = require('../../components/UserAuthentication/ForgotPassword/ForgotPasswordBody/ForgotPasswordBody');var _ForgotPasswordBody2 = _interopRequireDefault(_ForgotPasswordBody);
var _ForgotPasswordFooter = require('../../components/UserAuthentication/ForgotPassword/ForgotPasswordFooter/ForgotPasswordFooter');var _ForgotPasswordFooter2 = _interopRequireDefault(_ForgotPasswordFooter);
var _UpdatePassword = require('../../components/UserAuthentication/UpdatePassword/UpdatePassword');var _UpdatePassword2 = _interopRequireDefault(_UpdatePassword);
var _ChangePassword = require('../../components/UserAuthentication/ChangePassword/ChangePassword');var _ChangePassword2 = _interopRequireDefault(_ChangePassword);

var _constants = require('../../constants');
var _validate = require('../../utils/validate');






var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _checkers = require('../../utils/checkers');
var _services = require('../../services');

var _UserAuthentication = require('./UserAuthentication.scss');var styles = _interopRequireWildcard(_UserAuthentication);
var _UserAuthenticationPageModal = require('../../pages/UserAuthenticationPage/UserAuthenticationPageModal');var _UserAuthenticationPageModal2 = _interopRequireDefault(_UserAuthenticationPageModal);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var modalsWithoutCloseButton = [_constants.authenticationModalType.SEND_EMAIL_SUCCESS, _constants.authenticationModalType.PASSWORD_UPDATED,
_constants.authenticationModalType.PASSWORD_CHANGED,
_constants.authenticationModalType.PASSWORD_CHANGE_FAILED];var


UserAuthentication = function (_Component) {_inherits(UserAuthentication, _Component);function UserAuthentication() {var _temp, _this, _ret;_classCallCheck(this, UserAuthentication);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showPreloader: false,
      emailSent: _this.props.userAuthentication.emailSent,
      userEmail: '',
      emailIsValid: false,
      phoneIsValid: false,
      passwordIsValid: false,
      licenseNumberIsValid: false,
      companyNameIsValid: false,
      isTemporaryEmail: false }, _this.


    componentWillMount = function () {
      if (_this.props.token) {
        _this.props.verifyToken(_this.props.token);
      }

      var modalType = (0, _get2.default)(_this.props, 'userAuthentication.authenticationModalType');
      var recordRequired = [
      _constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE
      // authenticationModalType.DEFAULT
      ].some(function (type) {return type === modalType;});

      if (__CLIENT__) {
        if (recordRequired) {
          _services.MouseFlowService.initialize().then(function () {
            _services.MouseFlowService.startRecording();
            _services.MouseFlowService.tagRecord(modalType);
          });
        }

        if (_this.props.isMobile) {
          document.querySelector('#content').classList.add('no-display');
        }
      }
    }, _this.



































































    hideModal = function () {
      if (_this.props.userAuthentication.authenticationModalType === _constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE) {
        _this.props.logOut();
      }
      _this.props.onRequestClose();
    }, _this.

    hideMessageModal = function () {
      _this.props.hideMessageModal();
    }, _this.

    forgotPassword = function () {
      _this.props.switchAuthModalType({ bodyType: _constants.authenticationModalType.FORGOT_PASSWORD });
    }, _this.

    knowPassword = function () {
      _this.props.onRequestClose();
      _this.props.switchAuthModalType({
        bodyType: _constants.authenticationModalType.DEFAULT,
        selectedTab: _constants.userAuthenticationTabs.SIGN_IN });

      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/' + _constants.userAuthenticationPageTabs.SIGN_IN));
    }, _this.

    sendEmail = function (email) {
      _this.setState({
        userEmail: email });

      _this.props.sendEmail({ email: email, locale: _this.props.locale });
    }, _this.

    updatePassword = function (password) {
      _this.props.updatePassword({ password: password, token: _this.props.token });
    }, _this.

    changePassword = function (value) {
      _this.props.changePassword(value);
    }, _this.

    validateEmail = function (value) {
      var email = value.replace(/\s/g, '');

      var emailIsValid = (0, _validate.emailRegexValidation)(email);
      var phoneIsValid = (0, _validate.phoneRegexValidation)(value.replace(/\s/g, ''));
      var result = false;var
      modalType = _this.props.userAuthentication.authenticationModalType;
      var temporaryModal = modalType === _constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE;

      if (emailIsValid || phoneIsValid) {
        result = true;
      } else if (!result) {
        result = false;
      } else if (temporaryModal) {
        result = _this.props.userAuthentication.data.email !== email && !(0, _checkers.isTemporaryEmail)(email);
      }

      _this.setState(Object.assign({
        emailIsValid: result ? emailIsValid : false,
        phoneIsValid: result ? phoneIsValid : false },
      temporaryModal && { isTemporaryEmail: (0, _checkers.isTemporaryEmail)(email) }));


      return result;
    }, _this.

    validatePassword = function (password) {
      var result = (0, _validate.passwordValidation)(password);
      _this.setState({ passwordIsValid: result });

      return result;
    }, _this.

    validateLicenseNumber = function (license) {
      var result = (0, _validate.licenseNumberValidation)(license);
      _this.setState({ licenseNumberIsValid: result });

      return result;
    }, _this.

    validateCompanyName = function (companyName) {
      var companyNameIsValid = (0, _validate.companyNameValidation)(companyName);
      _this.setState({ companyNameIsValid: companyNameIsValid });
      return companyNameIsValid;
    }, _this.

    triggerPressEnter = function (keyCode, target) {
      if (keyCode === _constants.enterKey) {
        target.click && target.click();
      }
    }, _this.

    openMessage = function (type) {
      var tryAgainButton = _this.submitButton(_this.props.translate('userAuthentication', 'tryAgain'), _this.hideMessageModal);
      var okButton = _this.submitButton(_this.props.translate('userAuthentication', 'forgotPassword', 'ok'), function () {_this.hideMessageModal();_this.hideModal();});

      switch (type) {
        case _constants.authenticationModalType.SEND_EMAIL_FAIL:{
            _this.forgotPassword();
            _this.props.openMessageModal({
              message:
              _react2.default.createElement('div', { className: 'contentMessage' },
                _react2.default.createElement('div', null, _this.props.translate('userAuthentication', 'emailSent', 'emailWasNotSent')),
                tryAgainButton) });



            break;
          }
        case _constants.authenticationModalType.SEND_EMAIL_SUCCESS:{
            _this.forgotPassword();
            _this.props.openMessageModal({
              message:
              _react2.default.createElement('div', { className: 'contentMessage' },
                _react2.default.createElement('div', { className: styles.noTitleContent }, _this.props.translate('userAuthentication', 'emailSent', 'description'))) });



            break;
          }
        case _constants.authenticationModalType.TOKEN_INVALID:{
            _this.forgotPassword();
            _this.props.openMessageModal({
              message:
              _react2.default.createElement('div', { className: 'contentMessage' },
                _react2.default.createElement('div', { className: styles.centered }, _this.props.translate('userAuthentication', 'invalidTokenMessage', 'part1')),
                _react2.default.createElement('div', { className: styles.centered }, _this.props.translate('userAuthentication', 'invalidTokenMessage', 'part2')),
                tryAgainButton) });



            break;
          }
        case _constants.authenticationModalType.PASSWORD_UPDATED:{
            _this.props.switchAuthModalType({ bodyType: _constants.authenticationModalType.RESET_PASSWORD });
            _this.props.openMessageModal({
              message:
              _react2.default.createElement('div', { className: 'contentMessage' },
                _react2.default.createElement('div', {
                    className: styles.content },
                  _this.props.translate('userAuthentication', 'passwordUpdatedMessage')),

                okButton),


              isCloseButtonInvisible: true });

            break;
          }
        case _constants.authenticationModalType.PASSWORD_UPDATE_FAILED:{
            _this.props.switchAuthModalType({ bodyType: _constants.authenticationModalType.RESET_PASSWORD });
            _this.props.openMessageModal({
              message:
              _react2.default.createElement('div', { className: 'contentMessage' },
                _react2.default.createElement('div', {
                    className: styles.content },
                  _this.props.translate('userAuthentication', 'passwordUpdateFailedMessage')),

                okButton) });



            break;
          }
        case _constants.authenticationModalType.PASSWORD_CHANGED:{
            _this.props.switchAuthModalType({ bodyType: _constants.authenticationModalType.CHANGE_PASSWORD });
            _this.props.openMessageModal({
              message:
              _react2.default.createElement('div', { className: 'contentMessage' },
                _react2.default.createElement('div', null,
                  _react2.default.createElement('p', null, _this.props.translate('userAuthentication', 'passwordChangedMessage')))) });




            break;
          }
        case _constants.authenticationModalType.PASSWORD_CHANGE_FAILED:{
            _this.props.switchAuthModalType({ bodyType: _constants.authenticationModalType.CHANGE_PASSWORD });
            _this.props.openMessageModal({
              message:
              _react2.default.createElement('div', { className: 'contentMessage' },
                _react2.default.createElement('div', null,
                  _react2.default.createElement('p', null, _this.props.translate('userAuthentication', 'passwordChangeFailedMessage')))) });




            break;
          }
        default:break;}

    }, _this.

    submitButton = function (translation, action) {return (
        _react2.default.createElement('div', { className: styles.buttonLine },
          _react2.default.createElement('button', {
              className: 'btn btn-primary',
              type: 'submit',
              onClick: action },

            translation)));}, _temp), _possibleConstructorReturn(_this, _ret);}UserAuthentication.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var userData = newProps.userAuthentication,isOpen = newProps.isOpen,isMessageModalOpen = newProps.isMessageModalOpen;var _props$userAuthentica = this.props.userAuthentication,loading = _props$userAuthentica.loading,emailSent = _props$userAuthentica.emailSent,userIsAuthorized = _props$userAuthentica.userIsAuthorized,authModalType = _props$userAuthentica.authenticationModalType;var stateModifier = {};if (userData && userData.loading !== loading) {stateModifier.showPreloader = userData.loading;}if (userData && userData.loading !== loading) {stateModifier.showPreloader = userData.loading;}if (userData && userData.emailSent !== emailSent) {stateModifier.emailSent = userData.emailSent;}if (userData && userData.userIsAuthorized && userData.userIsAuthorized !== userIsAuthorized) {if (userData.data) {_constants.storage.value.setItem('userData', JSON.stringify(userData.data));(0, _analyticsManager.setAnalyticsProviderData)({ userId: userData.data.id });(0, _analyticsManager.setAnalyticsProviderData)({ dimension1: userData.data.is_agent ? 'realtor' : 'regular' });}if ((0, _checkers.isTemporaryEmail)(userData.data.email)) {this.props.openAuthenticationModal({ bodyType: _constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE }).then(function () {_services.MouseFlowService.initialize().then(function () {_services.MouseFlowService.startRecording();_services.MouseFlowService.tagRecord(_constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE);});});} else {this.props.onRequestClose();}}if (this.props.isMobile && userData.authenticationModalType !== authModalType) {this.openMessage(userData.authenticationModalType);}if (authModalType === _constants.authenticationModalType.CHANGE_PASSWORD && !isMessageModalOpen && isMessageModalOpen !== this.props.isMessageModalOpen) {if (userData && !userData.error) {this.hideModal();}}if (!isOpen && isOpen !== this.props.isOpen) {// Redirect
      if (this.props.token) {_reactRouter.browserHistory.push((0, _appendLocale2.default)(this.props.locale, '/'));}}if (Object.keys(stateModifier).length) {this.setState(stateModifier);}};UserAuthentication.prototype.componentWillUnmount = function componentWillUnmount() {_services.MouseFlowService.stopRecording();document.querySelector('#content').classList.remove('no-display');};UserAuthentication.prototype.



  render = function render() {var _this2 = this;
    var forgotPasswordFooter =
    _react2.default.createElement(_ForgotPasswordFooter2.default, {
      translate: this.props.translate('userAuthentication', 'forgotPassword'),
      knowPassword: this.knowPassword });



    var tryAgainButton = this.submitButton(this.props.translate('userAuthentication', 'tryAgain'), this.forgotPassword);
    var okButton = this.submitButton(this.props.translate('userAuthentication', 'forgotPassword', 'ok'), this.hideModal);
    var loading = this.props.userAuthentication && this.props.userAuthentication.loading;

    var modalBody = function modalBody(type) {
      switch (type) {
        case _constants.authenticationModalType.RESET_PASSWORD:{
            return (
              _react2.default.createElement(_UpdatePassword2.default, {
                translate: _this2.props.translate('userAuthentication', 'updatePassword'),
                updatePassword: _this2.updatePassword,
                validatePassword: _this2.validatePassword,
                triggerPressEnter: _this2.triggerPressEnter,
                isMobile: _this2.props.isMobile,
                isRtl: _this2.props.isRtl }));

          }
        case _constants.authenticationModalType.CHANGE_PASSWORD:{
            return (
              _react2.default.createElement(_ChangePassword2.default, {
                loading: loading,
                translate: _this2.props.translate('userAuthentication', 'changePassword'),
                changePassword: _this2.changePassword,
                validatePassword: _this2.validatePassword,
                triggerPressEnter: _this2.triggerPressEnter,
                access_token: _this2.props.userAuthentication.data ? _this2.props.userAuthentication.data.access_token : '',
                isMobile: _this2.props.isMobile,
                isRtl: _this2.props.isRtl }));

          }
        case _constants.authenticationModalType.FORGOT_PASSWORD:{
            var errorMessage = _this2.props.userAuthentication.error ?
            _this2.props.translate('userAuthentication', 'emailSent', 'noUserMessage')() : '';
            return (
              _react2.default.createElement('div', null,
                _react2.default.createElement('div', { className: 'user-auth-title' },
                  _react2.default.createElement('span', { className: styles.title },
                    _this2.props.translate('userAuthentication', 'forgotPassword', 'title'))),



                _react2.default.createElement(_ForgotPasswordBody2.default, {
                  openMessageModal: _this2.props.openMessageModal,
                  hideMessageModal: _this2.props.hideMessageModal,
                  translate: _this2.props.translate('userAuthentication', 'forgotPassword'),
                  sendEmail: _this2.sendEmail,
                  validateEmail: _this2.validateEmail,
                  errorMessage: errorMessage,
                  loading: loading,
                  triggerPressEnter: _this2.triggerPressEnter,
                  isMobile: _this2.props.isMobile,
                  isRtl: _this2.props.isRtl }),

                forgotPasswordFooter));

          }

        case _constants.authenticationModalType.TOKEN_INVALID:{
            if (_this2.props.isMobile) {
              break;
            } else {
              return (
                _react2.default.createElement('div', { className: styles.invalidModal },
                  _react2.default.createElement('div', { className: styles.noTitleContent },
                    _react2.default.createElement('div', {
                        className: styles.centered },
                      _this2.props.translate('userAuthentication', 'invalidTokenMessage', 'part1')),

                    _react2.default.createElement('div', {
                        className: styles.centered },
                      _this2.props.translate('userAuthentication', 'invalidTokenMessage', 'part2'))),


                  _react2.default.createElement('div', { className: styles.centered }, tryAgainButton)));


            }
          }

        case _constants.authenticationModalType.SEND_EMAIL_SUCCESS:{
            if (_this2.props.isMobile) {
              break;
            } else {
              return (
                _react2.default.createElement('div', { className: styles.invalidModal + ' ' + styles.centered },
                  _react2.default.createElement('div', { className: styles.noTitleContent }, _this2.props.translate('userAuthentication', 'emailSent', 'description')),
                  okButton));


            }
          }

        case _constants.authenticationModalType.SEND_EMAIL_FAIL:{
            if (_this2.props.isMobile) {
              break;
            } else {
              return (
                _react2.default.createElement('div', { className: styles.invalidModal + ' ' + styles.centered },
                  _react2.default.createElement('div', { className: styles.noTitleContent }, _this2.props.translate('userAuthentication', 'emailSent', 'emailWasNotSent')),
                  tryAgainButton));


            }
          }
        case _constants.authenticationModalType.PASSWORD_UPDATED:{
            if (_this2.props.isMobile) {
              break;
            } else {
              return (
                _react2.default.createElement('div', { className: styles.invalidModal + ' ' + styles.centered },
                  _react2.default.createElement('div', {
                      className: styles.content },
                    _this2.props.translate('userAuthentication', 'passwordUpdatedMessage')),

                  okButton));


            }
          }
        case _constants.authenticationModalType.PASSWORD_UPDATE_FAILED:{
            if (_this2.props.isMobile) {
              break;
            } else {
              return (
                _react2.default.createElement('div', { className: styles.invalidModal + ' ' + styles.centered },
                  _react2.default.createElement('div', {
                      className: styles.content },
                    _this2.props.translate('userAuthentication', 'passwordUpdateFailedMessage')),

                  okButton));


            }
          }
        case _constants.authenticationModalType.PASSWORD_CHANGED:{
            return (
              _react2.default.createElement('div', { className: styles.invalidModal + ' ' + styles.centered + ' ' + styles.passwordChanged },
                _react2.default.createElement('div', { className: styles.content },
                  _this2.props.translate('userAuthentication', 'passwordChangedMessage')),

                okButton));


          }
        case _constants.authenticationModalType.PASSWORD_CHANGE_FAILED:{
            if (_this2.props.isMobile) {
              break;
            } else {
              return (
                _react2.default.createElement('div', { className: styles.invalidModal + ' ' + styles.centered + ' ' + styles.passwordChanged },
                  _react2.default.createElement('div', {
                      className: styles.content },
                    _this2.props.translate('userAuthentication', 'passwordChangeFailedMessage')),

                  okButton));


            }
          }
        case _constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE:{
            return (
              _react2.default.createElement('div', { className: styles.updateTemporaryProfile },
                _react2.default.createElement('div', { className: 'user-auth-title' },
                  _react2.default.createElement('span', { className: styles.title }, '' + _this2.props.translate('userAuthentication', 'title'))),

                _react2.default.createElement('div', { className: styles.indentedDescription }, '' + _this2.props.translate('userAuthentication', 'descriptionForTemporaryUser')),
                _react2.default.createElement(_components.UserAuthenticationForm, {
                  locale: _this2.props.locale,
                  translate: _this2.props.translate('userAuthentication', 'newAccountTab'),
                  authenticateUser: _this2.props.authenticateUser,
                  checkPhone: _this2.props.checkPhone,
                  authenticateUserByNumber: _this2.props.authenticateUserByNumber,
                  userAuthentication: _this2.props.userAuthentication,
                  validateEmail: _this2.validateEmail,
                  validatePassword: _this2.validatePassword,
                  emailIsValid: _this2.state.emailIsValid,
                  phoneIsValid: _this2.state.phoneIsValid,
                  passwordIsValid: _this2.state.passwordIsValid,
                  triggerPressEnter: _this2.triggerPressEnter,
                  isMobile: _this2.props.isMobile,
                  isRtl: _this2.props.isRtl,
                  editUserProfile: _this2.props.editUserProfile,
                  isTemporaryEmail: _this2.state.isTemporaryEmail,
                  formIsActive: true })));



          }
        default:{
            return (
              _react2.default.createElement('div', null,
                _react2.default.createElement('div', { className: 'user-auth-title' },
                  _react2.default.createElement('span', { className: styles.title },

                    _this2.props.isMobile ?

                    _react2.default.createElement('img', {
                      width: '88px',
                      src: _constants.onMapLogoBlue,
                      alt: '',
                      title: '' + _this2.props.translate('header', 'onMapHomepage') }) :


                    _this2.props.translate('userAuthentication', 'title'))),



                _react2.default.createElement(_UserAuthenticationPageModal2.default, {
                  contentClassName: styles.newAuthModalContent })));



          }}

      return undefined;
    };var

    modalType = this.props.userAuthentication.authenticationModalType;
    var isCloseButtonInvisible = modalsWithoutCloseButton.includes(modalType);

    return (
      _react2.default.createElement(_components.Modal, {
          isOpen: this.props.isOpen,
          onRequestClose: this.hideModal,
          className: 'userAuthenticationModal',
          isCloseButtonInvisible: isCloseButtonInvisible,
          isMobile: this.props.isMobile,
          translate: this.props.translate,
          isRtl: this.props.isRtl,
          plain: this.props.isMobile,
          overlayClassName: styles.modalOverlayClassName },

        _react2.default.createElement('div', { className: styles.userAuthenticationContent },
          modalBody(this.props.userAuthentication.authenticationModalType))));



  };return UserAuthentication;}(_react.Component);


UserAuthentication.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  isOpen: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  selectedTab: _propTypes2.default.number,
  authenticateUser: _propTypes2.default.func,
  checkPhone: _propTypes2.default.func,
  authenticateUserByNumber: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  userAuthentication: _propTypes2.default.object,
  token: _propTypes2.default.string,
  verifyToken: _propTypes2.default.func,
  updatePassword: _propTypes2.default.func,
  changePassword: _propTypes2.default.func,
  sendEmail: _propTypes2.default.func,
  socialNetworkAuthentication: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  switchAuthModalType: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  isMessageModalOpen: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  logOut: _propTypes2.default.func.isRequired,
  editUserProfile: _propTypes2.default.func.isRequired,
  clearUserAuthentication: _propTypes2.default.func };exports.default =


UserAuthentication;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserAuthentication/UserAuthentication.js
// module id = 3055
// module chunks = 0